import {
  COLUMNS_CONFIG,
  DEFAULT_COLUMNS,
  FIELDS,
  SUBSCRIPTIONS,
} from 'frontend/organization-users/organization-users-table-helpers'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'

export const OrganizationUserDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}




